module.exports = __webpack_public_path__ + "img/img0.73e7f8d8.jpg";